import { FC, useState } from 'react';
import { Button } from '@heroui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faSatellite, faMap } from '@fortawesome/free-solid-svg-icons';
import satelliteImg from '../../../../assets/images/image-layers/satellite_square.png';
import standartImg from '../../../../assets/images/image-layers/standart_square.png';
import { MapBoxGlobeMapStyles } from '../../../../utils/mapHelpers';

interface IMapLayerChangerProps {
	changeMapStyle: (event: any) => void;
	mapStyle: string;
	isEnabled?: boolean;
}
const MapLayerChanger: FC<IMapLayerChangerProps> = ({ ...props }) => {
	const [layerText, setLayerText] = useState('Layers');

	return (
		<div className="absolute z-10 opacity-85 -ml-2 cursor-pointer" style={{ bottom: 10, right: 96 }}>
			<Button
				isDisabled={!props.isEnabled}
				isIconOnly={false}
				className="flex flex-col items-center justify-end w-[57px] h-[58px] rounded shadow-lg overflow-hidden border border-white"
				style={{
					backgroundImage: `url(${props.mapStyle === MapBoxGlobeMapStyles.Msi_Day || props.mapStyle === MapBoxGlobeMapStyles.Msi_Dusk ? satelliteImg : standartImg})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
				onMouseEnter={() => {
					props.mapStyle === MapBoxGlobeMapStyles.Msi_Day || props.mapStyle === MapBoxGlobeMapStyles.Msi_Dusk
						? setLayerText('Satellite')
						: setLayerText('Map');
				}}
				onMouseLeave={() => setLayerText('Layers')}
				title="Map Layer Changer"
				onPress={() => {
					props.changeMapStyle(
						(props.mapStyle === MapBoxGlobeMapStyles.Msi_Day && MapBoxGlobeMapStyles.Msi_Day_Satellite) ||
							(props.mapStyle === MapBoxGlobeMapStyles.Msi_Dusk && MapBoxGlobeMapStyles.Msi_Dusk_Satellite) ||
							(props.mapStyle === MapBoxGlobeMapStyles.Msi_Day_Satellite && MapBoxGlobeMapStyles.Msi_Day) ||
							(props.mapStyle === MapBoxGlobeMapStyles.Msi_Dusk_Satellite && MapBoxGlobeMapStyles.Msi_Dusk),
					);
				}}
			>
				<div className="w-full text-white  flex-row items-center gap-1">
					{(layerText === 'Layers' && <FontAwesomeIcon size="xl" icon={faLayerGroup} />) ||
						(layerText === 'Satellite' && <FontAwesomeIcon size="xl" icon={faSatellite} />) ||
						(layerText === 'Map' && <FontAwesomeIcon size="xl" icon={faMap} />)}
					<p className="text-sm">{layerText}</p>
				</div>
			</Button>
		</div>
	);
};

export default MapLayerChanger;
